import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ElTableColumnActions',
  setup(__props) {

// No props needed - everything via $attrs pass-through
// No emits needed - events handled by el-table-column natively
// Ultra-simple component - just a wrapper with CSS

return { __sfc: true, }
}

})